import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { HttpmethodsService } from "src/app/demo/service/httpmethods.service";
import { LoginMaster } from "src/app/demo/ui-elements/ui-basic/modelClass";
import {
  checkLogin,
  forgotPassword,
  loginMasterUrl,
} from "src/app/demo/ui-elements/ui-basic/modelurl";

@Component({
  selector: "app-auth-signin",
  templateUrl: "./auth-signin.component.html",
  styleUrls: ["./auth-signin.component.scss"],
})
export class AuthSigninComponent implements OnInit {
  loginMasterFrom: FormGroup;

  loginMaster = new LoginMaster();
  constructor(
    public formBuilder: FormBuilder,
    private httpService: HttpmethodsService,
    private router: Router,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.loginMasterFrom = this.formBuilder.group({
      staffMobileNumber: new FormControl("", Validators.required),
      staffPassword: new FormControl("", Validators.required),
    });
  }
  get Validation() {
    return this.loginMasterFrom.controls;
  }
  login(loginMaster) {
    this.httpService
      .postRequest(loginMasterUrl + checkLogin, loginMaster)
      .subscribe(
        (result: any) => {
          if (result.flag) {
            localStorage.setItem("staffId", result.staffId);
            localStorage.setItem("staffFullName", result.staffFullName);
            localStorage.setItem("roleId", result.roleId);
            localStorage.setItem("roleName", result.roleName);
            localStorage.setItem("privilegeData", result.privilegeData);
            sessionStorage.setItem("reload", "true");
            this.toastr.success(result.message, "SUCCESS");
            if (result.roleName == "Admin") {
              this.router.navigateByUrl("selectbranchmaster");
              this.loginMasterFrom.reset();
            } else {
              if (result.branchMasterList.length == 1) {
                localStorage.setItem(
                  "branchId",
                  result.branchMasterList[0].branchId
                );
                localStorage.setItem(
                  "branchName",
                  result.branchMasterList[0].branchName
                );
                this.router.navigateByUrl("dashboard/default");
                this.loginMasterFrom.reset();
              } else {
                this.router.navigateByUrl("selectbranchmaster");
                this.loginMasterFrom.reset();
              }
            }
          } else {
            this.toastr.error(result.message, "ERROR");
            this.loginMasterFrom.reset();
          }
        },
        (error) => {
          this.toastr.error("Please try again", "ERROR");
        }
      );
  }

  forgotPassword(mobileNumber) {
    this.httpService
      .getRequest(loginMasterUrl + forgotPassword + mobileNumber)
      .subscribe(
        (result: any) => {
          this.toastr.success("Send Message", "SUCCESS");
        },
        (error) => {
          this.toastr.error("Please try again", "ERROR");
        }
      );
  }
}
